<script>
import {useToast} from "vue-toastification";
import VueTimepicker from 'vue3-timepicker'
import 'vue3-timepicker/dist/VueTimepicker.css'

export default {
  components: {
    VueTimepicker,
  },
  mixins: [

  ],
  props: [
      'drupal_input_id', // The ID of hidden input element where we will add all ID's of selected user(s)
      'empty_text', // Shown when the no users are selected
  ],
  async mounted() {
    // Setup toast
    this.toast = useToast();
    // Check if drupal_input_id already has a value
    const element = this.drupalInputElement();
    if (element.value) {
      // Convert string to json
      this.dimming_schemas = JSON.parse(element.value);
      // Add unique id to each time
      this.addUniqueIdToAllTimeSchemas();
    }
    else {
      // Set default dimming schema
      this.dimming_schemas = [
        {
          id: this.newUniqueId(),
          is_default: true,
          schema: [
            {
              time: '00:00',
              percentage: 100,
              dimming: 0,
              id: this.newUniqueId(),
            }
          ]
        }
      ];
    }
    // Open the first dimming schema panel if there is only one dimming schema
    if (this.dimming_schemas.length === 1) {
      this.panel = 0;
    }
  },
  data () {
    return {
      panel: null,
      toast: null,
      drag: false,
      uniqueId: 0,
      dimming_schemas: [],
    }
  },
  computed: {

  },
  watch: {
    dimming_schemas: {
      handler(newValue, oldValue) {
        // Make sure dimming is min 0 and max 100
        this.limitPercentageOnAllSchemas();
        // Update the dimming schema in the Drupal DOM input element
        this.updateDrupalInputElement(newValue);
        // Check if there are any errors in the dimming schema
        if (this.dimmingSchemasHaveErrors()) {
          this.disableDrupalSubmitButton();
        }
        else {
          this.enableDrupalSubmitButton();
        }
      },
      deep: true
    },
  },
  methods: {
    updateDrupalInputElement(value) {
      const element = this.drupalInputElement();
      // Convert JSON to string and set value in the Drupal DOM input element
      element.value = JSON.stringify(value);
    },
    drupalInputElement() {
      // Get the Drupal DOM input element
      const element_id = "#"+this.drupal_input_id;
      const element = document.querySelector(element_id);
      return element;
    },
    deleteTime(dimming_schema, index) {
      // Remove the time from the dimming schema
      dimming_schema.schema.splice(index, 1);
    },
    addTime(dimming_schema) {
      // Get the highest time
      const highest_time = this.getHighestTimeInSchema(dimming_schema.schema);
      // Add a new time to the dimming schema
      dimming_schema.schema.push({
        time: highest_time,
        percentage: 100,
        id: this.newUniqueId(),
      });
    },
    getHighestTimeInSchema(schema) {
      // Get the highest time in the dimming schema
      let highest_time = '00:00';
      for (const time of schema) {
        if (time.time.localeCompare(highest_time) > 0) {
          highest_time = time.time;
        }
      }
      return highest_time;
    },
    getHighestStartDate() {
      // Get the highest start date
      let highest_date = '1-1';
      for (const dimming_schema of this.dimming_schemas) {
        if (!dimming_schema.start) {
          continue;
        }
        if (dimming_schema.start.localeCompare(highest_date) > 0) {
          highest_date = dimming_schema.start;
        }
      }
      return highest_date;
    },
    sortTime(schema, index) {
      // Sort the time in the dimming schema
      schema.sort((a, b) => {
        return a.time.localeCompare(b.time);
      });
      // Update the dimming schema with the new sorted time
      this.dimming_schemas[index].schema = schema;
    },
    /**
     * Sort the dimming schemas by start day.
     * Zero pad the month and day to make sure the sort string comparison is correct.
     */
    sortDimmingSchemas() {
      this.dimming_schemas.sort((a, b) => {
        // Don't sort when there is no start date
        if (!a.start || !b.start) {
          return 0;
        }
        // Create a date string with month and day reversed
        const a_date = this.getMonthZeroPadded(a.start) + '-' + this.getDayZeroPadded(a.start);
        const b_date = this.getMonthZeroPadded(b.start) + '-' + this.getDayZeroPadded(b.start);
        // Compare dates
        return a_date.localeCompare(b_date);
      });
    },
    addSchema() {
      // Add a new dimming schema to the list
      this.dimming_schemas.push({
        id: this.newUniqueId(),
        start: this.getHighestStartDate(),
        end: '31-12',
        schema: [{
          time: '00:00',
          percentage: 100,
          id: this.newUniqueId(),
        }]
      });
    },
    deleteSchema(index) {
      // Remove the dimming schema from the list
      this.dimming_schemas.splice(index, 1);
    },
    limitPercentageOnAllSchemas() {
      // Make sure dimming is min 0 and max 100.
      for (const dimming_schema of this.dimming_schemas) {
        for (const time of dimming_schema.schema) {
          if (time.percentage < 0) {
            time.percentage = 0;
          }
          else if (time.percentage > 100) {
            time.percentage = 100;
          }
          // When empty, make the dimming 0
          else if (time.percentage === '') {
            time.percentage = 100;
          }
          // Make sure the dimming is a number (remove leading zero's)
          time.percentage = parseInt(time.percentage);
        }
      }
    },
    newUniqueId() {
      this.uniqueId++;
      return this.uniqueId;
    },
    addUniqueIdToAllTimeSchemas() {
      // Add unique id to each dimming schema
      for (const dimming_schema of this.dimming_schemas) {
        dimming_schema.id = this.newUniqueId();
      }
      // Add unique id to each time
      for (const dimming_schema of this.dimming_schemas) {
        for (const time of dimming_schema.schema) {
          time.id = this.newUniqueId();
        }
      }
    },
    updateDay(index, date, newValue) {
      // Set new end day for the dimming schema
      this.dimming_schemas[index][date] = newValue + '-' + this.getMonth(this.dimming_schemas[index][date]);
    },
    updateMonth(index, date, newValue) {
      // Set new end month for the dimming schema
      this.dimming_schemas[index][date] = this.getDay(this.dimming_schemas[index][date]) + '-' + newValue;
    },
    getDay(date) {
      return date.split('-')[0];
    },
    getMonth(date) {
      return date.split('-')[1];
    },
    getDayZeroPadded(date) {
      return this.getDay(date).padStart(2, '0');
    },
    getMonthZeroPadded(date) {
      return this.getMonth(date).padStart(2, '0');
    },
    // Check if the dimming schema start with a time of 00:00
    checkFirstTimeIsMidnight(dimming_schema) {
      // Check if dimming schema has a time at all.
      if (dimming_schema.schema.length === 0) {
        return false;
      }
      // Check if the first time is 00:00
      if (dimming_schema.schema[0].time !== '00:00') {
        return false;
      }
      return true;
    },
    // Check if there are duplicate times in the dimming schema
    checkDuplicateTimes(dimming_schema) {
      const times = [];
      for (const time of dimming_schema.schema) {
        if (times.includes(time.time)) {
          return true;
        }
        times.push(time.time);
      }
      return false;
    },
    /**
     * Check if start date is before end date.
     * Zero pad the month and day to make sure the string comparison is correct.
     *
     * @param dimming_schema
     * @returns {boolean}
     */
    checkStartDateBeforeEndDate(dimming_schema) {
      // Don't check the default schema, it has no dates.
      if (dimming_schema.is_default) {
        return true;
      }

      const start_date = this.getMonthZeroPadded(dimming_schema.start) + '-' + this.getDayZeroPadded(dimming_schema.start);
      const end_date = this.getMonthZeroPadded(dimming_schema.end) + '-' + this.getDayZeroPadded(dimming_schema.end);
      if (start_date.localeCompare(end_date) > 0) {
        return false;
      }
      return true;
    },
    /**
     * Check if the start date of the current dimming schema is after the end date of the previous dimming schema
     * Zero pad the months and days to make sure the string comparison is correct.
     *
     * @param dimming_schema
     * @returns {boolean}
     */
    checkStartDateIsAfterPreviousEndDate(dimming_schema) {
      // Get the index
      let index = this.dimming_schemas.findIndex(e => e.id === dimming_schema.id);

      // First dimming schema is always valid (that's the default schema)
      // Second dimming schema is always valid (that's the first custom schema)
      if (index === 0 || index === 1) {
        return true;
      }

      // Get previous end date and the current start date
      const previous_end_date = this.dimming_schemas[index - 1].end;
      const previous_end_date_zero_padded = this.getMonthZeroPadded(previous_end_date) + '-' + this.getDayZeroPadded(previous_end_date);
      const current_start_date_zero_padded = this.getMonthZeroPadded(dimming_schema.start) + '-' + this.getDayZeroPadded(dimming_schema.start);

      if (current_start_date_zero_padded.localeCompare(previous_end_date_zero_padded) < 1) {
        return false;
      }
      return true;
    },
    // Check if there are any errors in the dimming schema
    dimmingSchemeHasErrors(dimming_schema) {
      if (this.checkStartDateIsAfterPreviousEndDate(dimming_schema) === false) {
        return true;
      }
      if (this.checkStartDateBeforeEndDate(dimming_schema) === false) {
        return true;
      }
      if (this.checkFirstTimeIsMidnight(dimming_schema) === false) {
        return true;
      }
      if (this.checkDuplicateTimes(dimming_schema)) {
        return true;
      }
      return false;
    },
    // Check if there are any errors in any of the dimming schemas
    dimmingSchemasHaveErrors() {
      for (const dimming_schema of this.dimming_schemas) {
        if (this.dimmingSchemeHasErrors(dimming_schema)) {
          return true;
        }
      }
      return false;
    },
    // Convert month numbers to month names
    monthNumberToName(month) {
      const months = [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december',
      ];
      return months[month - 1];
    },
    // Get the drupal submit button outside Vue
    getDrupalSubmitButton() {
      return document.querySelector('[data-drupal-selector="edit-submit"]');
    },
    // Disable the drupal submit button
    disableDrupalSubmitButton() {
      let drupal_submit_button = this.getDrupalSubmitButton();
      drupal_submit_button.disabled = true;
    },
    // Enable the drupal submit button
    enableDrupalSubmitButton() {
      let drupal_submit_button = this.getDrupalSubmitButton();
      drupal_submit_button.disabled = false;
    },
  }
}
</script>


<template>

  <div>

    <template v-if="dimming_schemas.length === 0">
      Nog geen dimschemas toegevoegd.
    </template>
    <v-expansion-panels
      v-model="panel"
    >
      <v-expansion-panel
        v-for="(dimming_schema, dimming_schema_index) in dimming_schemas"
        :key="dimming_schema.start"
        :value="dimming_schema.id"
      >
        <v-expansion-panel-title>

          <div class="d-flex justify-space-between w-100">
            <div v-if="dimming_schema.is_default">
              <h3>Standaard dimschema</h3>
              <p class="text-medium-emphasis mb-0">Het standaard dimschema wordt gebruikt als er geen andere dimschema's op de datum zijn.</p>
            </div>
            <h3 class="ma-0" v-else>
              <v-icon v-if="dimmingSchemeHasErrors(dimming_schema)" color="error">mdi-close-circle</v-icon>
              <span class="text-medium-emphasis">Dimschema</span> {{ getDay(dimming_schema.start) }} {{ monthNumberToName(getMonth(dimming_schema.start)) }} <span class="text-medium-emphasis">tot en met</span> {{ getDay(dimming_schema.end) }} {{ monthNumberToName(getMonth(dimming_schema.end)) }}
            </h3>
            <v-btn @click.stop="deleteSchema(dimming_schema_index)" color="error" class="ma-0" size="small" v-if="!dimming_schema.is_default">
              Verwijder dimschema
            </v-btn>
          </div>

        </v-expansion-panel-title>
        <v-expansion-panel-text>

          <v-alert
            variant="tonal"
            type="error"
            class="mt-1 mb-2"
            v-if="checkStartDateIsAfterPreviousEndDate(dimming_schema) === false"
          >
            De startdatum van dit dimschema moet n&aacute; de einddatum van het vorige schema zijn.
          </v-alert>

          <v-alert
            variant="tonal"
            type="error"
            class="mt-1 mb-2"
            v-if="checkStartDateBeforeEndDate(dimming_schema) === false"
          >
            De startdatum van dit dimschema moet voor n&aacute; de einddatum van dit dimschema zijn.
          </v-alert>

          <template v-if="!dimming_schema.is_default">
            <strong>Dimschema actief van</strong>
            <div class="d-flex align-center">
              <select
                :value="getDay(dimming_schema.start)"
                class="form-element form-select form-element--type-select"
                @input="updateDay(dimming_schema_index, 'start', $event.target.value)"
                @change="sortDimmingSchemas"
              >
                <option v-for="n in 31" :key="n">{{ n }}</option>
              </select>

              <select
                :value="getMonth(dimming_schema.start)"
                class="form-element form-select form-element--type-select"
                @input="updateMonth(dimming_schema_index, 'start', $event.target.value)"
                @change="sortDimmingSchemas"
              >
                <option v-for="n in 12" :key="n" :value="n">{{ monthNumberToName(n) }}</option>
              </select>

              <span class="mx-1">tot en met</span>

              <select
                :value="getDay(dimming_schema.end)"
                class="form-element form-select form-element--type-select"
                @input="updateDay(dimming_schema_index, 'end', $event.target.value)"
                @change="sortDimmingSchemas"
              >
                <option v-for="n in 31" :key="n">{{ n }}</option>
              </select>

              <select
                :value="getMonth(dimming_schema.end)"
                class="form-element form-select form-element--type-select"
                @input="updateMonth(dimming_schema_index, 'end', $event.target.value)"
                @change="sortDimmingSchemas"
              >
                <option v-for="n in 12" :key="n" :value="n">{{ monthNumberToName(n) }}</option>
              </select>

            </div>
          </template>

          <v-sheet :width="500" border class="mt-3">
            <v-table density="comfortable" class="dimming-schema-table">
              <thead>
              <tr>
                <th class="text-left">
                  Tijd
                </th>
                <th class="text-left">
                  Percentage
                </th>
                <th class="text-left">

                </th>
              </tr>
              </thead>

              <tr v-if="checkFirstTimeIsMidnight(dimming_schema) === false">
                <td colspan="3">
                  <v-alert
                    variant="tonal"
                    type="error"
                    class="mb-2"
                  >
                    De eerste tijd in het schema moet 00:00 uur zijn.
                  </v-alert>
                </td>
              </tr>

              <tr v-if="checkDuplicateTimes(dimming_schema)">
                <td colspan="3">
                  <v-alert
                    variant="tonal"
                    type="error"
                    class="mb-2"

                  >
                    Er staan dubbele tijden in dit schema.
                  </v-alert>
                </td>
              </tr>

              <TransitionGroup name="fade" tag="tbody" v-if="dimming_schema.schema.length">
                <tr v-for="(time, index) in dimming_schema.schema" :key="time.id">
                  <td>
                    Vanaf
                    <vue-timepicker
                      v-model="time.time"
                      :minute-interval="5"
                      auto-scroll
                      hide-clear-button
                      @change="sortTime(dimming_schema.schema, dimming_schema_index)"
                    ></vue-timepicker>
                  </td>
                  <td>
                    <input
                      class="form-text form-element"
                      :value="time.percentage"
                      @input="time.percentage = $event.target.value"
                      type="number"
                      min="0"
                      max="100"
                    /> %
                  </td>
                  <td>
                    <v-btn block @click="deleteTime(dimming_schema, index)" color="error" size="small">
                      Verwijder
                    </v-btn>
                  </td>
                </tr>
              </TransitionGroup>
              <template v-else>
                <tr>
                  <td colspan="3">
                    Geen tijden toegevoegd
                  </td>
                </tr>
              </template>
            </v-table>

            <div class="pa-2">
              <v-btn block @click="addTime(dimming_schema)" color="primary">
                Tijd toevoegen
              </v-btn>
            </div>

          </v-sheet>
        </v-expansion-panel-text>
      </v-expansion-panel>

    </v-expansion-panels>

    <v-btn @click="addSchema" color="primary" class="mt-3 mb-6">
      Dimschema toevoegen
    </v-btn>

  </div>

</template>

<style lang="scss">
.dimming-schema-card {
  overflow: visible; // Make sure the time picker dropdown is visible
  z-index: 50; // Make sure the time picker dropdown is above the 'add dimschema' button
}
.dimming-schema-table {
  .v-table__wrapper {
    overflow: visible; // Make sure the time picker dropdown is visible
  }
  table {
    margin-top: 0;
    margin-bottom: 0;

    th {
      font-weight: bold !important;
    }
  }
}
.vue__time-picker {
  .dropdown {
    height: 17em;

    .select-list {
      height: 17em;
    }
  }
}
/* 1. declare transition */
.fade-move,
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

/* 2. declare enter from and leave to state */
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scaleY(0.01) translate(30px, 0);
}

/* 3. ensure leaving items are taken out of layout flow so that moving
      animations can be calculated correctly. */
.fade-leave-active {
  position: absolute;
}
</style>
